import React from "react"
import "./DeclineSuggestionButton.scss"
import { DECLINE_BUTTON } from "../../../constants/messages"
import { DislikeFilled } from "@ant-design/icons"
import { Button } from "../../../atoms"

const DeclineSuggestionButton = (props) => {
  return (
    <div id="DeclineSuggestionButton">
      <Button onClick={props.declined}>
        <DislikeFilled />
      </Button>
    </div>
  )
}

export default DeclineSuggestionButton
